/* eslint-disable */
// ./src/App
<template>
    <v-app id="app">
        <router-view></router-view>
    </v-app>
</template>

<script>

    export default {
        name: 'app',
        data() {
            return {}
        },
        created: function () {

        },
        computed: {


        },
        components: {
        }
    }
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Work+Sans&display=swap');
html, body{
    font-family: 'Work Sans', sans-serif;
}
#app{
    font-family: 'Work Sans', sans-serif;
}

</style>
